export default "__VITE_ASSET__v7pBK5Ff__"